// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__sx7Nc","inner":"Footer_inner__2jrSq","nextIcon":"Footer_nextIcon__2_aGB","innerLeft":"Footer_innerLeft__29KDH"};